const baseAdvertUrl = "Advert"




  const endpoints = {
    getMessageGroupList:`${baseAdvertUrl}/GetMessageGroupList`,
    getMessageGroupDetail:`${baseAdvertUrl}/GetMessageGroupDetail`,
    changeUserBlockStatus:`${baseAdvertUrl}/BlockByUser`,
    reportUser:`${baseAdvertUrl}/ReportUser`,
    deleteAllMessages:`${baseAdvertUrl}/DeleteMessaging`,
    complaintByUser:`${baseAdvertUrl}/ComplaintByUser`,
 
  };
  
  export default endpoints;
  